(function () {
  'use strict';
  if (window.ByteRescueUI) return;
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;
  var lastScrollY = window.scrollY;
  var headerTicking = false;
  var scrollDirection = 'none';
  var scrollIntentStartY = window.scrollY;
  var mobileRequestIdleTimer = null;
  var mobileRequestIdleDelay = 3000;
  function publishAnalyticsEvent(name, detail) {
    var eventName = 'byterescue:' + name;
    var eventData = detail || {};

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, eventData);
      }
    } catch (error) {
      // Analytics must never interrupt the customer journey.
    }

    try {
      document.dispatchEvent(new CustomEvent('byterescue:analytics', {
        detail: { name: eventName, data: eventData }
      }));
    } catch (error) {
      // The DOM event is only a non-networked test hook for local regression.
    }
  }

  function publishSuccessfulContactEvents() {
    scopedNodes(document, '[data-analytics-lead-success]').forEach(function (marker) {
      var leadType = marker.getAttribute('data-analytics-lead-success') || 'contact';
      var historyState = window.history.state || {};
      var recordedTypes = historyState.brLeadSuccess || {};
      if (recordedTypes[leadType]) return;
      try {
        var nextState = Object.assign({}, historyState);
        nextState.brLeadSuccess = Object.assign({}, recordedTypes);
        nextState.brLeadSuccess[leadType] = true;
        window.history.replaceState(nextState, document.title, window.location.href);
      } catch (error) {
        // Continue without de-duplication if history state is unavailable.
      }
      publishAnalyticsEvent('generate_lead', { lead_type: leadType });
    });
  }

  function scopedNodes(scope, selector) {
    var found = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.nodeType === 1 && scope.matches(selector)) found.unshift(scope);
    return found;
  }

  function uiMessage(node, key, fallback) {
    if (!node) return fallback || '';
    return node.getAttribute('data-message-' + key) || fallback || '';
  }

  function setSerialHelp(widget, open, restoreFocus) {
    if (!widget) return;
    var toggle = widget.querySelector('[data-serial-help-toggle]');
    var panel = widget.querySelector('[data-serial-help-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    widget.classList.toggle('is-open', open);
    document.body.classList.toggle('br-help-open', open || Boolean(document.querySelector('[data-serial-help].is-open')));
    if (!open && restoreFocus) {
      widget.setAttribute('data-serial-suppress-focus', 'true');
      toggle.focus();
      window.setTimeout(function () { widget.removeAttribute('data-serial-suppress-focus'); }, 0);
    }
  }

  function closeSerialHelps(except, restoreFocus) {
    scopedNodes(document, '[data-serial-help].is-open').forEach(function (widget) {
      if (widget !== except) setSerialHelp(widget, false, restoreFocus);
    });
  }

  function initializeSerialHelp(scope) {
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    scopedNodes(scope, '[data-serial-help]').forEach(function (widget) {
      if (widget.getAttribute('data-serial-help-bound') === 'true') return;
      widget.setAttribute('data-serial-help-bound', 'true');
      widget.setAttribute('data-serial-hover', supportsHover ? 'true' : 'false');
      if (supportsHover) {
        widget.addEventListener('mouseenter', function () {
          closeSerialHelps(widget, false);
          setSerialHelp(widget, true, false);
        });
        widget.addEventListener('mouseleave', function () {
          if (!widget.contains(document.activeElement)) setSerialHelp(widget, false, false);
        });
      }
      widget.addEventListener('focusin', function () {
        if (widget.getAttribute('data-serial-suppress-focus') === 'true') return;
        closeSerialHelps(widget, false);
        setSerialHelp(widget, true, false);
      });
      widget.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!widget.contains(document.activeElement)) setSerialHelp(widget, false, false);
        }, 0);
      });
    });
  }

  function fillMessage(template, replacements) {
    var output = String(template || '');
    Object.keys(replacements || {}).forEach(function (key) {
      output = output.split('__' + key + '__').join(String(replacements[key] == null ? '' : replacements[key]));
    });
    return output;
  }

  function prepareReveals(scope, immediate) {
    scopedNodes(scope, '.br-reveal').forEach(function (item) {
      if (immediate || reduceMotion || item.getBoundingClientRect().top <= window.innerHeight * 1.05) {
        item.classList.add('is-visible');
      } else if (revealObserver) {
        revealObserver.observe(item);
      } else {
        item.classList.add('is-visible');
      }
    });
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -32px' });
  }

  prepareReveals(document, false);
  root.classList.remove('no-js');
  root.classList.add('br-has-js');

  function currentHeader() { return document.querySelector('[data-site-header]'); }
  function updateMenuBounds() {
    var header = currentHeader();
    var nav = header && header.querySelector('[data-mobile-nav]');
    if (!nav || nav.hidden) return;
    var viewport = window.visualViewport;
    var bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    nav.style.maxHeight = Math.max(0, bottom - nav.getBoundingClientRect().top - 12) + 'px';
  }
  function clearMobileRequestIdleTimer() {
    if (!mobileRequestIdleTimer) return;
    window.clearTimeout(mobileRequestIdleTimer);
    mobileRequestIdleTimer = null;
  }
  function sectionTouchesViewport(section) {
    if (!section) return false;
    var rect = section.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function mobileRequestIsEligible(mobileRequest, requestSection) {
    if (!mobileRequest || window.innerWidth > 580 || document.body.classList.contains('br-menu-open')) return false;
    var serviceArea = document.querySelector('[data-service-area]');
    if (sectionTouchesViewport(serviceArea) || sectionTouchesViewport(requestSection)) return false;
    return window.scrollY > 180;
  }
  function scheduleMobileRequestReveal() {
    clearMobileRequestIdleTimer();
    mobileRequestIdleTimer = window.setTimeout(function () {
      mobileRequestIdleTimer = null;
      var mobileRequest = document.querySelector('[data-mobile-request]');
      var requestSection = document.querySelector('[data-request-section]');
      if (!mobileRequest) return;
      mobileRequest.classList.toggle('is-visible', mobileRequestIsEligible(mobileRequest, requestSection));
    }, mobileRequestIdleDelay);
  }
  function closeLanguageSelectors(returnFocus) {
    scopedNodes(document, '[data-language-selector][open]').forEach(function (selector) {
      selector.removeAttribute('open');
      if (returnFocus) {
        var summary = selector.querySelector('[data-language-summary]');
        if (summary) summary.focus();
      }
    });
  }
  function closeMenu(returnFocus) {
    var header = currentHeader();
    if (!header) return;
    var toggle = header.querySelector('[data-menu-toggle]');
    var nav = header.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.getAttribute('data-open-label') || 'Open navigation menu');
    nav.hidden = true;
    var wasOpen = document.body.classList.contains('br-menu-open');
    document.body.classList.remove('br-menu-open');
    header.classList.remove('is-hidden');
    if (wasOpen) scheduleMobileRequestReveal();
    if (returnFocus) toggle.focus();
  }

  function updateHeader() {
    var header = currentHeader();
    var currentY = window.scrollY;
    var delta = currentY - lastScrollY;
    var nextDirection = delta > 0 ? 'down' : (delta < 0 ? 'up' : scrollDirection);
    if (nextDirection !== scrollDirection) {
      scrollDirection = nextDirection;
      scrollIntentStartY = currentY;
    }
    var intentDistance = Math.abs(currentY - scrollIntentStartY);
    var beyondHero = currentY > Math.max(380, window.innerHeight * 0.62);
    if (header) {
      header.classList.toggle('is-scrolled', currentY > 28);
      if (beyondHero && scrollDirection === 'down' && intentDistance > 58 && !document.body.classList.contains('br-menu-open')) header.classList.add('is-hidden');
      if ((scrollDirection === 'up' && intentDistance > 34) || currentY < 130 || document.body.classList.contains('br-menu-open')) header.classList.remove('is-hidden');
    }
    var backTop = document.querySelector('[data-back-top]');
    if (backTop) backTop.classList.toggle('is-visible', beyondHero);
    var mobileRequest = document.querySelector('[data-mobile-request]');
    var requestSection = document.querySelector('[data-request-section]');
    if (mobileRequest) {
      var mobileRequestEligible = mobileRequestIsEligible(mobileRequest, requestSection);
      if (!mobileRequestEligible) {
        mobileRequest.classList.remove('is-visible');
        clearMobileRequestIdleTimer();
      } else if (delta < 0) {
        mobileRequest.classList.add('is-visible');
        clearMobileRequestIdleTimer();
      } else if (delta > 0) {
        mobileRequest.classList.remove('is-visible');
        scheduleMobileRequestReveal();
      } else if (!mobileRequest.classList.contains('is-visible') && !mobileRequestIdleTimer) {
        scheduleMobileRequestReveal();
      }
    }
    lastScrollY = currentY;
    headerTicking = false;
    updateMenuBounds();
  }
  function requestHeaderUpdate() {
    if (headerTicking) return;
    headerTicking = true;
    window.requestAnimationFrame(updateHeader);
  }
  updateHeader();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1080) closeMenu(false);
    requestHeaderUpdate();
  });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', updateMenuBounds, { passive: true });
  document.addEventListener('transitionend', function (event) {
    if (document.body.classList.contains('br-menu-open') && event.target.closest('[data-site-header]')) updateMenuBounds();
  });

  if (!reduceMotion && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('pointermove', function (event) {
      var card = event.target.closest('[data-interactive-card]');
      if (card) {
        var rect = card.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        card.style.setProperty('--pointer-x', x.toFixed(1) + 'px');
        card.style.setProperty('--pointer-y', y.toFixed(1) + 'px');
      }
    }, { passive: true });
  }

  function formValue(form, name) {
    var fields = scopedNodes(form, '[name="' + name + '"]');
    if (!fields.length) return '';
    if (fields[0].type === 'radio' || fields[0].type === 'checkbox') {
      var checked = fields.filter(function (field) { return field.checked; })[0];
      return checked ? checked.value.trim() : '';
    }
    return fields[0].value.trim();
  }


  document.addEventListener('click', function (event) {
    var serialHelpToggle = event.target.closest('[data-serial-help-toggle]');
    if (serialHelpToggle) {
      var serialWidget = serialHelpToggle.closest('[data-serial-help]');
      var serialIsOpen = serialHelpToggle.getAttribute('aria-expanded') === 'true';
      closeSerialHelps(serialWidget, false);
      setSerialHelp(serialWidget, serialWidget.getAttribute('data-serial-hover') === 'true' ? true : !serialIsOpen, false);
      return;
    }
    var serialHelpClose = event.target.closest('[data-serial-help-close]');
    if (serialHelpClose) {
      setSerialHelp(serialHelpClose.closest('[data-serial-help]'), false, true);
      return;
    }
    if (!event.target.closest('[data-serial-help]')) closeSerialHelps(null, false);

    if (!event.target.closest('[data-language-selector]')) closeLanguageSelectors(false);
    var contactLink = event.target.closest('a[href^="mailto:"], a[href^="tel:"]');
    if (contactLink) {
      publishAnalyticsEvent('contact_link_clicked', {
        contact_method: contactLink.getAttribute('href').indexOf('mailto:') === 0 ? 'email' : 'phone'
      });
    }

    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var header = toggle.closest('[data-site-header]');
      var nav = header && header.querySelector('[data-mobile-nav]');
      if (!nav) return;
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(opening));
      closeLanguageSelectors(false);
      toggle.setAttribute('aria-label', opening ? (toggle.getAttribute('data-close-label') || 'Close navigation menu') : (toggle.getAttribute('data-open-label') || 'Open navigation menu'));
      nav.hidden = !opening;
      document.body.classList.toggle('br-menu-open', opening);
      if (opening) {
        clearMobileRequestIdleTimer();
        var mobileRequest = document.querySelector('[data-mobile-request]');
        if (mobileRequest) mobileRequest.classList.remove('is-visible');
        header.classList.remove('is-hidden');
        updateMenuBounds();
      } else {
        scheduleMobileRequestReveal();
      }
      return;
    }
    if (event.target.closest('[data-mobile-nav] a')) {
      closeMenu(false);
    } else {
      var openHeader = currentHeader();
      var openNav = openHeader && openHeader.querySelector('[data-mobile-nav]');
      if (openNav && !openNav.hidden && !event.target.closest('[data-mobile-nav]')) closeMenu(false);
    }

    var backTop = event.target.closest('[data-back-top]');
    if (backTop) {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }

  });
  document.addEventListener('keydown', function (event) {
    var header = currentHeader();
    var nav = header && header.querySelector('[data-mobile-nav]');
    if (event.key === 'Escape') {
      var openSerialHelp = document.querySelector('[data-serial-help].is-open');
      if (openSerialHelp) {
        setSerialHelp(openSerialHelp, false, true);
        return;
      }
      var openLanguage = document.querySelector('[data-language-selector][open]');
      if (openLanguage) {
        closeLanguageSelectors(true);
        return;
      }
      if (nav && !nav.hidden) closeMenu(true);
    }
    if (event.key === 'Tab' && nav && !nav.hidden) {
      var toggle = header.querySelector('[data-menu-toggle]');
      var focusable = [toggle].concat(scopedNodes(nav, 'a[href], button:not([disabled])')).filter(Boolean);
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('.br-business-contact-form:not([data-business-request-form])')) {
      publishAnalyticsEvent('request_started', {
        lead_type: 'business_inquiry',
        team_size: formValue(event.target, 'contact[team_size]') || 'not_selected'
      });
      return;
    }
    if (event.target.matches('.br-general-contact-form')) {
      publishAnalyticsEvent('request_started', { lead_type: 'general_contact' });
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-product-variant]')) return;
    var form = event.target.closest('.br-product-form');
    var option = event.target.options[event.target.selectedIndex];
    var price = document.querySelector('[data-product-price]');
    var submit = form && form.querySelector('[data-product-submit]');
    if (price && option) price.textContent = option.getAttribute('data-price') || '';
    if (submit && option) {
      var available = option.getAttribute('data-available') === 'true';
      submit.disabled = !available;
      submit.textContent = available ? (submit.getAttribute('data-add-label') || 'Add to cart') : (submit.getAttribute('data-unavailable-label') || 'Unavailable');
    }
  });


  publishSuccessfulContactEvents();
  initializeSerialHelp(document);
  document.addEventListener('shopify:section:load', function (event) {
    prepareReveals(event.target, true);
    updateHeader();
    initializeSerialHelp(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) { prepareReveals(event.target, true); });
  window.ByteRescueUI = Object.freeze({
    scopedNodes: scopedNodes, uiMessage: uiMessage, fillMessage: fillMessage,
    formValue: formValue, publishAnalyticsEvent: publishAnalyticsEvent, reduceMotion: reduceMotion,
    resetScrollIntent: function () { lastScrollY = window.scrollY; scrollDirection = 'none'; scrollIntentStartY = lastScrollY; }
  });
})();
